import { Logging, LoggingCode } from './types/logging'

export const getLoggingCodeMeta = (
	log: Logging
): LoggingCode | null => {
	if (
		typeof log.code === 'object' &&
		log.code !== null &&
		'code' in log.code
	) {
		return log.code as LoggingCode
	}

	if (log.loggingCode && typeof log.loggingCode === 'object') {
		return log.loggingCode
	}

	return null
}

export const getLoggingCodeValue = (log: Logging): string => {
	if (typeof log.code === 'string') {
		return log.code
	}

	if (
		log.code &&
		typeof log.code === 'object' &&
		'code' in log.code
	) {
		return String(log.code.code)
	}

	if (log.loggingCode?.code) {
		return log.loggingCode.code
	}

	return ''
}

export const getLoggingType = (log: Logging): string => {
	return getLoggingCodeMeta(log)?.type || log.type || ''
}

export const getLoggingSource = (log: Logging): string => {
	return getLoggingCodeMeta(log)?.source || log.source || ''
}

export const getLoggingIsError = (log: Logging): boolean => {
	if (typeof log.isError === 'boolean') {
		return log.isError
	}

	return Boolean(getLoggingCodeMeta(log)?.isError)
}

export const getLoggingNotify = (log: Logging): boolean => {
	if (typeof log.notify === 'boolean') {
		return log.notify
	}

	return Boolean(getLoggingCodeMeta(log)?.notify)
}
